import { SetsConst } from 'core/constant'
/**
 * 字符串长度截取
 * @param str 目标字符串
 * @param len 截取长度
 * @returns {*|string}
 */
export const cut = (str, len) => {
    return str.substr(0, len)
}

/**
 * 格式化数字
 * @param num 目标数字
 * @param digits 保留小数位数
 * @param force 是否强制保留 digits 位小数
 * @returns {*}
 */
export const toFixed = (num, digits = 1, force = false) => {
    if (!force) {
        if (+num === +(+num).toFixed()) {
            return num
        }
    }
    return (+num).toFixed(digits)
}

/**
 * 获取 url 的参数部分字符串
 * @param url url
 * @returns {*|string}
 */
export const getUrlParamStr = (url) => {
    return url.split('?')[ 1 ] || ''
}

/**
 * 参数字符串 —> obj 例如: a=1&b=2 -> {a:1, b:2}
 * @param paramStr
 * @returns {{}}
 */
export const paramStr2Obj = (paramStr) => {
    const obj = {}
    const _params = paramStr.split('&')
    for (const _param of _params) {
        if (_param.indexOf('=') === -1) {
            continue
        }
        const [_key, _val] = _param.split('=')
        obj[ _key ] = _val
    }
    return obj
}

/**
 * 往 url 中追加参数
 * @param url
 * @param params
 * @returns {*}
 */
export const addUrlParams = (url, params) => {
    if (!params) {
        return url
    }
    const result = []
    let keyValMap = {}
    let anchor = ''
    // 1. 去除锚点
    if (url.indexOf('#') !== -1) {
        anchor = url.split('#')[ 1 ]
    }
    // 2. 取出 url 中的参数至 Map 中
    if (url.indexOf('?') !== -1) {
        const [_urlWithoutParam, _urlParam] = url.split('?')
        result.push(_urlWithoutParam)
        keyValMap = paramStr2Obj(_urlParam)
    } else {
        result.push(url)
    }
    // 3. 补上 ?
    result.push('?')
    // 4. 将新的参数添加/ 覆盖至已存在的参数 Map 中
    for (const p in params) {
        if (!params.hasOwnProperty(p)) {
            continue
        }
        keyValMap[ p ] = params[ p ]
    }
    // 5. 迭代参数 Map , 在 ? 后面追加参数
    let _index = 0
    for (const key in keyValMap) {
        if (!keyValMap.hasOwnProperty(key)) {
            continue
        }
        const val = keyValMap[ key ]
        // 去除 false 的参数, 因为后台使用 Java 的 boolean 接收参数, 未传递的参数默认值为 false
        // 0 等值需要保留
        // '' 也去掉
        if (val === false || val === '') {
            continue
        }
        if (_index > 0) {
            result.push('&')
        }
        result.push(key)
        result.push('=')
        result.push(encodeURIComponent(keyValMap[ key ]))
        _index++
    }
    // 6. 放回锚点
    if (anchor) {
        result.push('#')
        result.push(anchor)
    }
    // done!
    return result.join('')
}

/**
 * trim
 * @param str
 */
export const trim = (str) => {
    return str ? str.trim() : ''
}

/**
 * 默认值
 * @param val
 * @param defValue
 * @returns {*}
 */
export const defVal = (val, defValue) => {
    return val || defValue
}

/**
 * Number 转中文数字
 * @param number 数字
 * @returns {string} 中文数字
 */
export const numberToChinese = (number) => {
    // 单位
    const units = '个十百千万@#%亿^&~'
    // 字符
    const chars = '零一二三四五六七八九'
    let a = (number + '').split('')
    let s = []
    let j
    if (a.length > 12) {
        throw new Error('too big')
    } else {
        for (let i = 0, j = a.length - 1; i <= j; i++) {
            // 两位数 处理特殊的 1*
            if (j === 1 || j === 5 || j === 9) {
                if (i === 0) {
                    if (a[ i ] !== '1') {
                        s.push(chars.charAt(a[ i ]))
                    }
                } else {
                    s.push(chars.charAt(a[ i ]))
                }
            } else {
                s.push(chars.charAt(a[ i ]))
            }
            if (i !== j) {
                s.push(units.charAt(j - i))
            }
        }
    }
    // 优先处理 零百 零千 等
    return s.join('').replace(/零([十百千万亿@#%^&~])/g, function (m, d, b) {
        b = units.indexOf(d)
        if (b !== -1) {
            if (d === '亿') {
                return d
            }
            if (d === '万') {
                return d
            }
            if (a[ j - b ] === '0') {
                return '零'
            }
        }
        return ''
        // 零百 零千处理后 可能出现 零零相连的 再处理结尾为零的
    }).replace(/零+/g, '零').replace(/零([万亿])/g, function (m, b) {
        return b
    }).replace(/亿[万千百]/g, '亿').replace(/[零]$/, '').replace(/[@#%^&~]/g, function (m) {
        return {
            '@': '十',
            '#': '百',
            '%': '千',
            '^': '十',
            '&': '百',
            '~': '千'
        }[ m ]
    }).replace(/([亿万])([一-九])/g, function (m, d, b, c) {
        c = units.indexOf(d)
        if (c !== -1) {
            if (a[ j - c ] === '0') {
                return d + '零' + b
            }
        }
        return m
    })
}

/**
 * 数字索引 -> 字母 例如: 0,1,2 -> A,B,C
 * @param number
 * @returns {string}
 */
export const number2Letter = (number) => {
    return String.fromCharCode('A'.charCodeAt(0) + number)
}

/**
 * 高亮文本中的关键字
 * @param val 目标文本
 * @param keyword 关键字
 * @returns {*}
 */
export const highlightByKeyword = (val, keyword) => {
    return keyword ? val.replace(new RegExp(keyword), '<span class="highlight">$&</span>') : val
}

/**
 * 是否是邮箱
 * @param val
 * @returns {boolean}
 */
export const isEmail = (val) => {
    return new RegExp(SetsConst.EMAIL_REGEX, 'i').test(val)
}

/**
 * 校验密码
 * @param val
 * @returns {{valid: boolean, err: string}}
 */
export const validatePassword = (val) => {
    let valid = false
    let err = ''
    if (!val.trim()) {
        err = '密码不能为空'
    } else if (val.length < 6) {
        err = '密码长度最小为 6 位'
    } else {
        valid = true
    }
    return { valid, err }
}

/**
 * 校验昵称
 * @param val
 * @returns {{valid: boolean, err: string}}
 */
export const validateNickname = (val) => {
    let valid = false
    let err = ''
    if (!val.trim()) {
        err = '姓名/昵称不能为空'
    } else if (/[<>(){}*#]/.test(val)) {
        err = '姓名/昵称不能包含特殊字符 <,>,(,),{,},*,#'
    } else if (val.length < 2) {
        err = '姓名/昵称长度最小为 2 位'
    } else if (val.length > 20) {
        err = '姓名/昵称长度最大为 20 位'
    } else {
        valid = true
    }
    return { valid, err }
}

/**
 * 校验帐号
 * @param val
 * @returns {{valid: boolean, type: string, err: string}}
 */
export const validateAccount = (val) => {
    let valid = true
    let type = ''
    let err = ''
    if (!val.trim()) {
        valid = false
        err = '帐号不能为空'
    } else if (isEmail(val)) {
        type = 'email'
        if (/[<>(){}*#]/.test(val)) {
            valid = false
            err = '帐号不能包含特殊字符 <,>,(,),{,},*,#'
        }
    } else if (/^\d+$/g.test(val)) {
        if (val.length < 8) {
            valid = false
            err = '帐号不能是纯数字'
        } else {
            type = 'phone'
        }
    } else {
        type = 'username'
        if (/[@<>(){}*#]/.test(val)) {
            valid = false
            err = '帐号不能包含特殊字符 @,<,>,(,),{,},*,#'
        }
    }
    if (/^_/.test(val)) {
        valid = false
        err = '帐号不能以 _ 开头'
    } else if (val.length < 4) {
        valid = false
        err = '帐号长度最小为 4 位'
    } else if (val.length > 20) {
        err = '帐号长度最大为 20 位'
    }
    return { valid, type, err }
}


// WEBPACK FOOTER //
// ./bootsets/utils/index.js